__turbopack_context__.v({
  "l": "Icon-module-scss-module__706Gfa__l",
  "m": "Icon-module-scss-module__706Gfa__m",
  "s": "Icon-module-scss-module__706Gfa__s",
  "xl": "Icon-module-scss-module__706Gfa__xl",
  "xs": "Icon-module-scss-module__706Gfa__xs",
});
